import locales from './defaultLocales.json';

type TLocale = {
  [key: string]: string | TLocale;
};

// this type collects all nested object keys
// this helps for knowing if passed locale string is correct
type Leaves<T> = T extends object
  ? {
      [K in keyof T]: `${Exclude<K, symbol>}${Leaves<T[K]> extends never
        ? ''
        : `.${Leaves<T[K]>}`}`;
    }[keyof T]
  : never;

type NestedObjectLeaves = Leaves<typeof locales>;

export const $l = (key: NestedObjectLeaves): string => {
  return (
    key.split('.').reduce<string | TLocale>((acc, el) => {
      if (typeof acc === 'string') {
        return '';
      }
      return acc[el];
    }, locales as TLocale) || ''
  ).toString();
};
